import { Container } from '@cleartrip/ct-design-components'

import { WorkplusCfwLogoSvg } from '@/components/home/CFW/WorkplusCfwLogoSvg'

import styles from './WorkplusCfwAccountBanner.module.scss'

export type WorkplusCfwAccountBannerProps = {
  visible: boolean
}


export function WorkplusCfwAccountBanner({ visible }: WorkplusCfwAccountBannerProps) {
  if (!visible) return null

  return (
    <Container className={`${styles.root} flex flex-column flex-middle px-2 py-3 bg-neutral-100`}>
      <Container className='flex flex-middle flex-center'>
        <WorkplusCfwLogoSvg />
      </Container>
    </Container>
  )
}
